import { Table } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledAccountLinkingDashboardTable = styled(Table)(({ theme }) => ({
    border: 0,
    paddingTop: 4,
    width: '98%',
    tableLayout: 'fixed',
    '.MuiTableCell-root': {
        fontSize: '16px',
        padding: '6px',
        fontFamily: ['Source Sans Pro'].join(','),
    },
    '.MuiTableCell-root:not(.collapsing-row > .MuiTableCell-root)': {
        height: '53px',
    },
    '.MuiTableCell-root:not(.no-truncate)': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    '.MuiTableCell-head': {
        color: theme.palette.info.light,
    },
    '.MuiTablePagination-actions': {
        color: theme.palette.primary.accent
    },
    '.MuiTableRow-root .inner-row': {
        backgroundColor: theme.palette.background.paper
    },
    '.MuiToolbar-root': {
        paddingRight: '40%'
    }
}));
